// Chakra imports
import { Flex, Text, UnorderedList, OrderedList, ListItem, useColorModeValue } from '@chakra-ui/react';

export default function Default(props: {
	includePadding: boolean;
}) {
	const textColor = useColorModeValue('secondaryGray.900', 'white');

	const paddignTop = props.includePadding ? { base: '130px', md: '80px', xl: '80px' } : { base: '0px' }

	return (
		<Flex direction={{ base: 'column' }} pt={ paddignTop }>
			<Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				Al ingresar el usuario a la página de servicios en línea de TAUREL acepta todos  los  términos  y  condiciones establecidas en el presente documento; contrato  que  al  ser  aceptado  se  entenderá  como  la convención   para   reglar   el   vínculo   jurídico   bilateral,  siendo  este  ley  entre  las  partes,  no  revocable  sino  por mutuo acuerdo o por las causas autorizadas por la Ley, siendo ejecutado de Buena Fe y obligándose no solamente a cumplir lo expresado en el presente documento, sino a todas las consecuencias que se derivan del mismo, según la equidad, el uso y la Ley.
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                Autorización para Reproducción
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				El usuario puede reproducir cualquier parte del material de esta página web sujeto a las siguientes condiciones:
                <UnorderedList>
                    <ListItem>El material solamente puede ser utilizado con propósitos informativos.</ListItem>
                    <ListItem>No puede modificarse en ningún modo.</ListItem>
                    <ListItem>No puede realizarse ninguna copia no autorizada de cualquier marca registrada de TAUREL.</ListItem>
                </UnorderedList>
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                Virus
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				TAUREL realizará todos los esfuerzos razonables para excluir virus incluidos en esta página web, pero no puede asegurar la exclusión total y no aceptará responsabilidad legal por tales virus. El usuario deberá adoptar las medidas apropiadas antes de descargar información de esta página web.
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                Divulgación de información
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				Toda la información brindada a TAUREL por el usuario de ésta página web se considerará confidencial y no será divulgada por TAUREL a ningún tercero, excepto en el caso que se requiera para la provisión de los servicios o una autoridad competente y en el ejercicio de sus funciones solicite información que considere necesaria.<br/><br/>
                Asimismo, TAUREL, no  garantiza  la  disponibilidad, continuidad  ni  la infalibilidad  del funcionamiento de esta página web, y en consecuencia excluye, en la máxima medida permitida por la legislación vigente, cualquier responsabilidad por los daños y perjuicios de toda naturaleza que puedan deberse  a  la  falta  de  disponibilidad o  de continuidad  del  funcionamiento  del  Sitio  y  de  los  servicios habilitados  en  el mismo.<br/><br/>
                Tampoco se hará responsable por la divulgación de información confidencial de o de los usuarios de esta página WEB como consecuencia de ataques cibernéticos o  de cualquier otra  forma de  ataque que vulnere  y exponga al público la información de los usuarios, así como sus contraseñas y direcciones. 
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                Exoneración De Responsabilidad:
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				El usuario acepta defender, exonerar y liberar de toda responsabilidad a TAUREL, sus licenciantes,  proveedores  y  cualquier  tercero proveedor  de  contenidos  a  la  información  y  servicios ofrecidos  y  sus respectivos  consejeros,  directivos, representantes  legales,  apoderados, empleados  y agentes por cualquier demanda, pérdida, gasto, daños que deriven de la utilización de la información y los servicios ofrecidos por TAUREL, en esta página WEB y que resulten de la violación de estos términos o de cualquier actividad relacionada con su cuenta (incluyendo conducta negligente o ilícita) por su parte o por la parte de cualquier usuario que acceda a nuestro sitio por medio de su cuenta.
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                De La Licencia Y Acceso A La Página Web
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				TAUREL, permite  utilizar  a el usuario una  licencia  limitada  para acceder  de  forma personal a su página WEB, www.XXXXXXXXX.com.ve y no para hacer modificaciones de ninguna  parte  del  mismo. 
                <OrderedList>
                    <ListItem>La página WEB  no podrá  ser  reproducida,  duplicada,  copiada,  vendida,  visitada o  utilizada  para  fines ilícitos.</ListItem>
                    <ListItem>Cualquier violación a las especificaciones anteriormente expuestas en este condicionado será procesada legalmente.</ListItem>
                </OrderedList>
			</Text>
            <Text color={textColor} fontSize='28px' fontWeight='700' mb='15px' lineHeight='100%'>
                De Los Derechos De Autor
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				Todo  el  contenido  de  la página WEB  de Servicios en Línea de Taurel:  textos,  gráficos,  logos,  fotografías, botones,  audio,  download  digitales,  compilaciones  de  data  y  software  es propiedad  de TAUREL y  está  avalado  y  protegido  por  las leyes  de derecho  de  autor  emitido  por  el  Servicio Autónomo de la Propiedad Intelectual (SAPI). (PATENTE EN PROCESO)<br/><br/>
                Este Contrato  de Adhesión  es Ley entre  las  partes,  su  cumplimiento  es  obligatorio,  lo  complementan las Leyes Orgánicas  y  Especiales,  Reglamentos,  la Constitución  de  la  República  Bolivariana  de Venezuela, Jurisprudencias  con  Valor  Vinculante, los  Pactos  Internacionales  de  Comercio,  suscritos por la Republica.
			</Text>
            <Text
				color={textColor}
				fontSize='lg'
				fontWeight='400'
				lineHeight='180%'
				w={{ base: '100%' }}
				maxW='100%'
				textAlign='justify'
				mb={{ base: '0px', md: '60px' }}>
				Estos  Términos  y  condiciones  entran  en  vigencia  a  partir de  su  publicación,  dando  por  notificada  su celebración,  obligando  a  las  partes  a  su  fiel  cumplimiento,  en  concordancia  con  los  artículos  1.333  y 1.159 del Código Civil Venezolano vigente.
			</Text>
		</Flex>
	);
}
